
import React from 'react';
import { Button } from '@/components/ui/button';
import { Check, ExternalLink } from 'lucide-react';
import Header from '@/components/join/Header';
import Footer from '@/components/join/Footer';

const CheckoutSuccess: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow flex items-center justify-center py-12 mt-16 md:mt-20">
        <div className="container max-w-2xl">
          <div className="bg-white rounded-xl p-8 text-center shadow-lg">
            <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6">
              <Check className="h-8 w-8 text-green-600" />
            </div>

            <h1 className="text-3xl font-bold mb-4">Welcome Aboard!</h1>

            <p className="text-gray-600 mb-6">
              We're thrilled to have you as a customer and can't wait to help you validate and market your product with scientific data.
            </p>

            <div className="bg-gradient-to-br from-blue-50 to-green-50 p-6 rounded-lg mb-8 border border-blue-100">
              <h2 className="text-lg font-semibold mb-3">What We're Building For You</h2>
              <p className="text-gray-700 mb-4">
                Our team is hard at work creating a powerful dashboard that will help you:
              </p>
              <ul className="flex flex-col items-center space-y-3 mx-auto max-w-md">
                <li className="flex items-start text-left">
                  <Check className="h-5 w-5 text-green-600 mr-2 mt-0.5 shrink-0" />
                  <span>Collect real scientific data on how your products affect blood glucose levels</span>
                </li>
                <li className="flex items-start text-left">
                  <Check className="h-5 w-5 text-green-600 mr-2 mt-0.5 shrink-0" />
                  <span>Generate trustworthy, verified testimonials from real users</span>
                </li>
                <li className="flex items-start text-left">
                  <Check className="h-5 w-5 text-green-600 mr-2 mt-0.5 shrink-0" />
                  <span>Create compelling marketing assets backed by scientific evidence</span>
                </li>
                <li className="flex items-start text-left">
                  <Check className="h-5 w-5 text-green-600 mr-2 mt-0.5 shrink-0" />
                  <span>Stand out in a crowded market with third-party validated claims</span>
                </li>
              </ul>
            </div>

            <div className="flex justify-center">
              <Button
                onClick={() => window.open('https://tastermonial.com', '_blank')}
                className="w-full sm:w-auto"
              >
                <ExternalLink className="mr-2 h-4 w-4" />
                Visit Tastermonial.com
              </Button>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default CheckoutSuccess;
